import { render } from "./page-tree.vue?vue&type=template&id=81901b46&scoped=true"
import script from "./page-tree.vue?vue&type=script&lang=js"
export * from "./page-tree.vue?vue&type=script&lang=js"

import "./page-tree.vue?vue&type=style&index=0&id=81901b46&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81901b46"]])

export default __exports__